<template>
	<el-card>
		<div v-if="getFormConfig" slot="header">
			<span v-html="clearPLabel(getFormConfig.label)"></span>
		</div>

		<div v-if="getBrandIdData">
			<el-radio-group v-model="brandId">
				<el-radio v-for="(item, index) in getBrandIdData.options" :key="index" :label="item.value">
					{{ item.label }}
				</el-radio>
			</el-radio-group>
		</div>
	</el-card>
</template>

<script>
import {clearPLabel} from 'meibao-insure/src/util/commonUtils'

export default {
	name: 'formBrandNew',
	components: {},
	data() {
		return {
			brandId: '',
		}
	},
	props: {
		brandFormAllData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
	},
	computed: {
		getFormConfig() {
			let {config = null} = this.brandFormAllData || {}
			return config
		},
		getBrandIdData() {
			let {brandId = null} = this.brandFormAllData || {}
			return brandId
		},
	},
	methods: {
		clearPLabel,
		//获取数据
		onGetSubBrandData() {
			return this.brandId
		},
		onSetBrandData(val) {
			this.brandId = val
		},
	},
	mounted() {},
	watch: {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
	line-height: 30px;
}
</style>
